// extracted by mini-css-extract-plugin
export var attribution = "_9x-4";
export var authorName = "_9x-5";
export var quote = "_9x-3";
export var testimonial = "_9x-2";
export var trustedBy = "_9x-0";
export var trustedByLabel = "_9x-1";